<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('eartag.Step1')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('eartag.Step1') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('eartag.Step2')" :class="activeStep >= 1 ? activeClass : ''"
                                                @click="activeStep = 1">
                                                <span>{{ $t('eartag.Step2') }}</span>
                                            </button> 
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('eartag.Step3')" :class="activeStep >= 2 ? activeClass : ''"
                                                @click="activeStep = 2">
                                                <span>{{ $t('eartag.Step3') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" 
                                                :title="$t('eartag.Step4')" :class="activeStep >= 3 ? activeClass : ''" 
                                                @click="activeStep = 3">
                                                {{ $t('eartag.Step3') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" 
                                                :title="$t('eartag.Step5')" :class="activeStep >= 4 ? activeClass : ''" 
                                                @click="activeStep = 4">
                                                {{ $t('eartag.Step5') }}
                                            </button>                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <keeper-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData"
                                            :nextStep="nextStep"
                                            :keepers="formData.keepers"
                                            @update:formData="updateFormData"
                                        />
                                        <animal-info 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            :animals="formData.animals"
                                            @update:formData="updateFormData"
                                        />
                                        <tag-info 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            :tags="formData.tags"
                                            @update:formData="updateFormData"
                                        />
                                        <date-info 
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"                                            
                                            :formData="formData"
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"                                            
                                            @update:formData="updateFormData"
                                        />
                                        <confirm-info
                                            v-if="activeStep === 4" 
                                            :class="activeStep === 4 ? activeClass : ''"
                                            :formData="formData"                                                                   
                                            :prevStep="prevStep"
                                            :emitter="emitter"
                                            ref="confirmInfoRef" 
                                        />
                                        <div class="button-row d-flex">
                                            <button v-if="activeStep === 4" @click="saveForm" class="btn mb-0 btn-sm bg-gradient-success null null ms-auto" type="button">{{ $t('common.Save') }}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>

import KeeperInfo from "./components/Keeper.vue";
import AnimalInfo from "./components/Animal.vue";
import TagInfo from "./components/Tag.vue";
import DateInfo from "./components/Date.vue";
import ConfirmInfo from "./components/Confirm.vue";

import * as Choices from "choices.js";
import { nextTick } from 'vue'
import axios from 'axios'
import mitt from 'mitt';

export default {
    name: 'Retagging_page',
    data() {
        return {
            emitter: mitt(),
            activeStep: 0,
            activeClass: "js-active position-relative",
            formSteps: 5,
            formData: {
                keeperId: '',
                keeperDetails: '',
                keeperUBN: '',
                rvoRelationnumber: '',
                animalId: '',
                animalDetails: '',
                tagId: '',
                tagDetails: '',
                reTagDate: null,
                keepers:[],
                animals:[],
                tags:[],
            },
            // Store Choices instance
            choicesInstanceKeeper: null,
            choicesInstanceAnimal: null,
            choicesInstanceTag: null            
        };
    },
    components: {
        KeeperInfo,
        AnimalInfo,
        TagInfo,
        DateInfo,
        ConfirmInfo        
    },
    async mounted() 
    {
        try {            
            await this.fetchAllKeepers();

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
    },    
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        }
    },
    methods: {
        async nextStep() {
            if (this.activeStep < this.formSteps -1) {
                this.activeStep += 1;
            } else {
                this.activeStep -= 1;
            }   

            if(this.activeStep == 1) {
                await this.fetchAllAnimals();
            }
            if(this.activeStep == 2) {
                alert('Next');
                await this.fetchAllTags();
            }
        },
        async prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;

                if(this.activeStep == 0) {                    
                    await this.fetchAllKeepers();
                }                
                if(this.activeStep == 1) {
                    await this.fetchAllAnimals();
                }
                if(this.activeStep == 2) {
                    alert('Previous');
                    await this.fetchAllTags();
                }
            }
        },        
        async fetchAllKeepers() 
        {
            try { 
                this.$store.commit('setShowLoading', true);
                
                const associationId = this.userRoleName === 'Admin' 
                    ? '' 
                    : this.$store.state.associationAdminAssociationId;

                // call API with associationId
                const response = await axios.get("user/getkeepers", {
                    params: { associationId }
                });
                
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.formData.keepers = result.data;
                } else {    
                    this.$showSuccess('errors.Error_fetching_keepers');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async fetchAllAnimals() 
        {
            try { 
                this.$store.commit('setShowLoading', true);
                
                const ubn = this.formData.keeperUBN || '';
                const response = await axios.get("Animal/getallretagging", {
                    params: {
                        ubn
                }});
                const result = response.data;
                if (result.success) {
                    if(result.count > 0 && Array.isArray(result.data)) {
                        this.formData.animals = result.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));                        
                    } else {
                        this.$showSuccess('errors.Success_no_animal_found');
                    }
                } else {
                    this.$showError(this.$t('errors.Error_fetching_animals'));
                }
                   
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },        
        async fetchAllTags()
        {
            this.$store.commit('setShowLoading', true);
            try { 
                
                const rvoRelationnumber = this.formData.rvoRelationnumber || '';
                const response = await axios.get("eartag/getbyrvorelationnumber", {
                    params: {
                        rvoRelationnumber
                }});

                const apiResult = response.data;

                if (apiResult.success && Array.isArray(apiResult.data)) {

                    this.formData.tags = apiResult.data;                    
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "tagId",
                        dataList: this.formData.tags,
                        selectedValue: this.formData.tagId,
                        instanceKey: "choicesInstanceTag"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_tags');
                }   
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },                            
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            // Destroy previous instance if it exists
            if (this[instanceKey]) {
                this[instanceKey].destroy();
            }

            // Initialize new Choices instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });

            // Set selected value if it exists in list
            if (selectedValue) {
                const optionExists = dataList.some(item => item.id === selectedValue);
                this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
            }
        },
        updateFormData(updatedData) {
            //this.formData = { ...this.formData, ...updatedData };
            Object.assign(this.formData, updatedData);
        },        
        async saveForm() {
            const isValid = await this.$refs.confirmInfoRef?.validateAndSubmit();
            if (!isValid) return;

            this.submitForm();
        },           
        async submitForm() {
            try {
                this.$store.commit('setShowLoading', true);

                //animalId: '',
                //tagId: '',
                //reTagDate: null,

                const formData = new FormData();
                const ignoredKeys = [
                    'keepers', 'animals', 'tags', 'keeperDetails', 'tagDetails', 'animalDetails', 'keeperId', 'keeperUBN', 'rvoRelationnumber'
                ];

                for (const key of Object.keys(this.formData)) {
                    if (ignoredKeys.includes(key)) continue;

                    const value = this.formData[key];
                    const isDateField = ['reTagDate'];

                    if (isDateField.includes(key) && value instanceof Date) {
                        formData.append(key, value.toISOString().split('T')[0]);
                    } else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }
               
                // Debug formData before sending
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                const response = await axios.post('/eartag/retagging', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                const result = response.data;

                if (result.success) {
                    this.$showSuccess('errors.Retagging_updated_successfully');
                    this.$router.push('/eartag');
                } else {
                    throw new Error('Form submission failed');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }
    }
}
</script>
<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}

.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}

.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}
</style>